export * from './baKameleonPicture.pipe';



// WEBPACK FOOTER //
// /app/src/app/theme/pipes/baKameleonPicture/index.ts